// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__iTM2O","pay":"AccountsPayableDetails_pay__Vz0ox"};